export default {
  editClientState: 'ok',
  listClientsState: 'in-progress',
  listClientsRecords: []
}
